module.exports = __webpack_public_path__ + "media/images/fullscreen/login2-8333319ef24ab86d768514ba509ce0bd.png";